<div class="vtr-widget-status"
	attr.aria-label="{{title}}-{{description}}">
	<div class="container-fluid">
		<div class="row">
			<div class="col">
				<div class="title"
					id="{{linkId}}-title"
					attr.aria-label="{{title}}">{{title}}</div>
				<div class="description"
					id="{{linkId}}-description"
					attr.aria-label="{{description}}">{{description}}</div>
			</div>
		</div>
	</div>
	<div class="row">
		<div class="col">
			<div class="text-center"
				*ngIf="items.length === 0">
				<vtr-spinner></vtr-spinner>
			</div>
			<vtr-ui-list-chevron [items]="items"
				*ngIf="items.length > 0"
				[linkId]="linkId"></vtr-ui-list-chevron>
		</div>
	</div>
</div>
